import {element_exists} from "../functions";

export var fnDashboardVoucherTable = function () {

    var tableName = '#dashboard-datatable-vouchers';

    if (!element_exists(tableName)) return false;
    var columns = [
        {data: 'Date'},
        {data: 'Text'},
        {data: 'Amount', render: $.fn.dataTable.render.number('.', ',', 2, '') },
        //{data: 'Amount'},
        {data: 'ContraAccountHandle_Number'},
        {data: 'uploaded'},
        {data: 'AccountHandle_Number'},
        {data: 'files_uploaded'},
        {data: 'deadline'}
    ];

    /*Rules for filling the columns*/
    var columnDefs = [
        {className: "p-l-10", width: "5%", targets: 0},
        {className: "p-l-10", width: "35%", targets: 1},
        {className: "p-l-10", width: "35%", targets: 2},
        {className: "p-l-10", width: "25%", targets: 3},
        {width: "25%", targets: 4},
        {width: "25%", targets: 5},
        {width: "25%", targets: 6},
        {className: "text-center", width: "25%", targets: 7},
    ];

    /*Important otherwise table misaligned*/
    $(tableName).css('width', '100%');
    var table = $(tableName).DataTable({
        language: allLangFiles.datatables,
        ajax: {
            url: '/getVouchers',
        },
        columns: columns,
        columnDefs: columnDefs,
        bFilter: false,
        destroy: true,
        bInfo: false,
        dom: 'frtipB',
        buttons: [
            'copy', 'csv', 'excel', 'pdf', 'print'
        ],
        bLengthChange: false,
        scrollX: true,
        lengthMenu: [10, 25, 50, 75, 100],
        initComplete: function (settings, json) {
            table.draw();
        },
    });
};